import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'upsc-document-required',
  templateUrl: './document-required.component.html',
  styleUrls: ['./document-required.component.scss']
})
export class DocumentRequiredComponent  {

  constructor(
    private dialogRef: MatDialogRef<DocumentRequiredComponent>,
    @Inject(MAT_LEGACY_DIALOG_DATA) public data: {docs: string[]}
  ) { }

  close(): void {
    console.log(this.data)
    this.dialogRef.close();
  }

}
